// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2802d8d8","213":"73523539","237":"7ee45d0b","411":"381bc674","455":"4f7e5903","480":"023589f8","529":"5c1194ee","744":"5a89fc1a","801":"52fd83a0"}[chunkId] + ".chunk.js";
};